(function () {
  const arreglo = [
    {
      fecha: "2018-01-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-01-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-01-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-01-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-01-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-01-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2018-01-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-01-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-01-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-01-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-01-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2018-01-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-01-25",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-01-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-01-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-01-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-01-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-01-31",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-02-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-02-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-02-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-02-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-02-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-02-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-02-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-02-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-02-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-02-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-02-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-02-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-02-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-02-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-02-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-02-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-02-22",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-02-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-02-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-02-26",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 4,
    },
    {
      fecha: "2018-02-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-02-28",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-03-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-03-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-03-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-03-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2018-03-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-03-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-03-10",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2018-03-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-03-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-03-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-03-15",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-03-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-03-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-03-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-03-23",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-03-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-03-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-03-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-03-30",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-04-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2018-04-03",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2018-04-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2018-04-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-04-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-04-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2018-04-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-04-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-04-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-04-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-04-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2018-04-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-04-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-04-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2018-04-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-04-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-04-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-04-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-04-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-05-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-05-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-05-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-05-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-05-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-05-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-05-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-05-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-05-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2018-05-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-05-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-05-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-05-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-05-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2018-05-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-05-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-05-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-05-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-05-29",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-05-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2018-05-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-06-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-06-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-06-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-06-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-06-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-06-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-06-07",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-06-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-06-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2018-06-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-06-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-06-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-06-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-06-19",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-06-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-06-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-06-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-06-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-06-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-06-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-06-28",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-06-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-07-02",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-07-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-07-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-07-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-07-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-07-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-07-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-07-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-07-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-07-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-07-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-07-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-07-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-07-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-07-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-07-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-07-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-07-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2018-07-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-07-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-08-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2018-08-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-08-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-08-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-08-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-08-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-08-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-08-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-08-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-08-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-08-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2018-08-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-08-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-08-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-08-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-08-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-08-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-08-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-08-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-08-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-09-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-09-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2018-09-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-09-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-09-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-09-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-09-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2018-09-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-09-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-09-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2018-09-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-09-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-09-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-09-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-09-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-09-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-09-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-10-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-10-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-10-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-10-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-10-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-10-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-10-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-10-15",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2018-10-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-10-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-10-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-10-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2018-10-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-10-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-11-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-11-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2018-11-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-11-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-11-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2018-11-13",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-11-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2018-11-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-11-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-11-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-11-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-11-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-11-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-11-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-11-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-11-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-11-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-11-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-12-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-12-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-12-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-12-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-12-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-12-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-12-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2018-12-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-12-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-12-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-12-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-12-15",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2018-12-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2018-12-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-12-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-12-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-12-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2018-12-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-12-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-12-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2018-12-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-01-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-01-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-01-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-01-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-01-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-01-08",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-01-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-01-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-01-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-01-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-01-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-01-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-01-16",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-01-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-01-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-01-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-01-22",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-01-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 8,
    },
    {
      fecha: "2019-01-24",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-01-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-01-26",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2019-01-27",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: null,
    },
    {
      fecha: "2019-01-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2019-01-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-01-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-01-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-02-01",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-02-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-02-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2019-02-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 7,
    },
    {
      fecha: "2019-02-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2019-02-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-02-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-02-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-02-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2019-02-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-02-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-02-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-02-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-02-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-02-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-02-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-02-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-02-25",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 8,
    },
    {
      fecha: "2019-02-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-02-27",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-02-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-03-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-03-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-03-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-03-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-03-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-03-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-03-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-03-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-03-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-03-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-03-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-03-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-03-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-03-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-03-18",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-03-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-03-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2019-03-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-03-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-03-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-03-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2019-03-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2019-03-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-03-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-04-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2019-04-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-04-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-04-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-04-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-04-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-04-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2019-04-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-04-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-04-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-04-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-04-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-04-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2019-04-17",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-04-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-04-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2019-04-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-04-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-04-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-04-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2019-04-29",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-04-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-05-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2019-05-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-05-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 7,
    },
    {
      fecha: "2019-05-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-05-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-05-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-05-10",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-05-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-05-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-05-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2019-05-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-05-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-05-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-05-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-05-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-05-20",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-05-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-05-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-05-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-05-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-05-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-05-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-05-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-05-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-06-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-06-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-06-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2019-06-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-06-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-06-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2019-06-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-06-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-06-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-06-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-06-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-06-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-06-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-06-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-06-20",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-06-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-06-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2019-06-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 8,
    },
    {
      fecha: "2019-06-26",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-06-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-06-28",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-06-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-06-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-07-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-07-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-07-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2019-07-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-07-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2019-07-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-07-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-07-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-07-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-07-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-07-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-07-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-07-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-07-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-07-21",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-07-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-07-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-07-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-07-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-07-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-07-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-07-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-08-02",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-08-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-08-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-08-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-08-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-08-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-08-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-08-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-08-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-08-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-08-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-08-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-08-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-08-20",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-08-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-08-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-08-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-08-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-08-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-08-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-09-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-09-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-09-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-09-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-09-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-09-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-09-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-09-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-09-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-09-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-09-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-09-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-09-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-09-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-09-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-09-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-09-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-09-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-09-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-10-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-10-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-10-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-10-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-10-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-10-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-10-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-10-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-10-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-10-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-10-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-10-15",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-10-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-10-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-10-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-10-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-10-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-10-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-10-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-10-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-10-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-10-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-10-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-10-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-11-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-11-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-11-05",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-11-07",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-11-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-11-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-11-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-11-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2019-11-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-11-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-11-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-11-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-11-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-11-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-12-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-12-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-12-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-12-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-12-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-12-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-12-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2019-12-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-12-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-12-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-12-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2019-12-24",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2019-12-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2019-12-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2020-01-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2020-01-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-01-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-01-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-01-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-01-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-01-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-01-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-01-17",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2020-01-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-01-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2020-01-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2020-01-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 8,
    },
    {
      fecha: "2020-01-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-01-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-01-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-01-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-01-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2020-01-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-02-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-02-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-02-05",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 3,
    },
    {
      fecha: "2020-02-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2020-02-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-02-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 7,
    },
    {
      fecha: "2020-02-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2020-02-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2020-02-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2020-02-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-02-17",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2020-02-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-02-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2020-02-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-02-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 8,
    },
    {
      fecha: "2020-02-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-02-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2020-02-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-02-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-02-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2020-02-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2020-02-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-03-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2020-03-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2020-03-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-03-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2020-03-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2020-03-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-03-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-03-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2020-03-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-03-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-03-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-03-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-03-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-03-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-03-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-03-21",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2020-03-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2020-03-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-03-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-04-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2020-04-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-04-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-04-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2020-04-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-04-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-04-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-04-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-04-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-04-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-04-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-04-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2020-05-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-05-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-05-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-05-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-05-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-05-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-05-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-06-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-06-15",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2020-06-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-08-24",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2020-08-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-09-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-09-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-09-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-09-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2020-11-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2021-02-04",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2021-05-06",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2021-08-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2021-09-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2021-11-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2021-12-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2021-12-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2022-05-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2022-05-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2022-06-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2022-08-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2022-09-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2022-09-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2022-10-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2022-10-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2022-11-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2022-11-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2022-11-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2022-12-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2022-12-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2022-12-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2022-12-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-01-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-01-31",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2023-02-09",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2023-02-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-03-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-03-19",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2023-03-20",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2023-04-30",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2023-05-25",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2023-05-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2023-06-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-06-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2023-06-20",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2023-06-27",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2023-07-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-07-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-07-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-07-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-07-18",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2023-07-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-07-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-08-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2023-08-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2023-08-11",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-08-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2023-08-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-08-29",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2023-09-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-09-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-09-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-09-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-10-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-10-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-10-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2023-10-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2023-10-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2023-10-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-11-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2023-11-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-11-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-11-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-11-09",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-11-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-11-20",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-11-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-11-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-11-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-12-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-12-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2023-12-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-12-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2023-12-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-01-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-01-04",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-01-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-01-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-01-13",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-01-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-01-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-01-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-01-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-01-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-01-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-02-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-02-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-02-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-02-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-02-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-02-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-02-23",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-02-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-03-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-03-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-03-05",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-03-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-03-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-03-11",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-03-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-03-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-03-19",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-03-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-03-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-03-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-03-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-04-02",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-04-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-04-09",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-04-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-04-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-04-16",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-04-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-04-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-04-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-04-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-04-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-04-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-05-02",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-05-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-05-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2024-05-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-05-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-05-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-05-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-05-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-05-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-05-21",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-05-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-05-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-05-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-05-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-05-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-05-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-05-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-05-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-06-03",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-06-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-06-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-06-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-06-10",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-06-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-06-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-06-13",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-06-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-06-20",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-06-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-06-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-06-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-06-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-07-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-07-02",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-07-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-07-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-07-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-07-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-07-08",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-07-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-07-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2024-07-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-07-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-07-17",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-07-18",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-07-19",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-07-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-07-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-07-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-07-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-07-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2024-07-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-07-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-07-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-08-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-08-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-08-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-08-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-08-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-08-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-08-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-08-12",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-08-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-08-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-08-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-08-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-08-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-08-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-08-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-08-21",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-08-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-08-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-08-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-08-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-08-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-08-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-09-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-09-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-09-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-09-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-09-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-09-08",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-09-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-09-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-09-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-09-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-09-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-09-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-09-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-09-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-09-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-09-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-09-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-09-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-09-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-10-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-10-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-10-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-10-06",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-10-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-10-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-10-09",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-10-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-10-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-10-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-10-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-10-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-10-25",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-10-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2024-10-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-11-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-11-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-11-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-11-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-11-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-11-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-11-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-11-24",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-11-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2024-11-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-11-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-12-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-12-03",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-12-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-12-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-12-09",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-12-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-12-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-12-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-12-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-12-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2024-12-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-12-16",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-12-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-12-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-12-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2024-12-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-12-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2024-12-29",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2024-12-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2024-12-31",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: null,
    },
    {
      fecha: "2025-01-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-01-03",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-01-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-01-06",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-01-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 8,
    },
    {
      fecha: "2025-01-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-01-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-01-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-01-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-01-13",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 6,
    },
    {
      fecha: "2025-01-14",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 7,
    },
    {
      fecha: "2025-01-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2025-01-16",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 7,
    },
    {
      fecha: "2025-01-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-01-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-01-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-01-20",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-01-21",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-01-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-01-23",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-01-24",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 6,
    },
    {
      fecha: "2025-01-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-01-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 11,
    },
    {
      fecha: "2025-01-28",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 8,
    },
    {
      fecha: "2025-01-29",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 9,
    },
    {
      fecha: "2025-01-30",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-01-31",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 6,
    },
    {
      fecha: "2025-02-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-02-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-02-04",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 12,
    },
    {
      fecha: "2025-02-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 11,
    },
    {
      fecha: "2025-02-06",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 10,
    },
    {
      fecha: "2025-02-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 7,
    },
    {
      fecha: "2025-02-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-02-10",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 11,
    },
    {
      fecha: "2025-02-11",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 9,
    },
    {
      fecha: "2025-02-12",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 12,
    },
    {
      fecha: "2025-02-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 10,
    },
    {
      fecha: "2025-02-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-02-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-02-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 13,
    },
    {
      fecha: "2025-02-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-02-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 14,
    },
    {
      fecha: "2025-02-20",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 8,
    },
    {
      fecha: "2025-02-21",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-02-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-02-24",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 13,
    },
    {
      fecha: "2025-02-25",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 6,
    },
    {
      fecha: "2025-02-26",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 12,
    },
    {
      fecha: "2025-02-27",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 10,
    },
    {
      fecha: "2025-02-28",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 8,
    },
    {
      fecha: "2025-03-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-03-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-03-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 28,
    },
    {
      fecha: "2025-03-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 23,
    },
    {
      fecha: "2025-03-05",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 13,
    },
    {
      fecha: "2025-03-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 16,
    },
    {
      fecha: "2025-03-07",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 11,
    },
    {
      fecha: "2025-03-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-03-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-03-10",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 15,
    },
    {
      fecha: "2025-03-11",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 23,
    },
    {
      fecha: "2025-03-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 14,
    },
    {
      fecha: "2025-03-13",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 11,
    },
    {
      fecha: "2025-03-14",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 17,
    },
    {
      fecha: "2025-03-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-03-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-03-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-03-18",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 23,
    },
    {
      fecha: "2025-03-19",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 16,
    },
    {
      fecha: "2025-03-20",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 13,
    },
    {
      fecha: "2025-03-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 11,
    },
    {
      fecha: "2025-03-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-03-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-03-24",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 22,
    },
    {
      fecha: "2025-03-25",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 9,
    },
    {
      fecha: "2025-03-26",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 11,
    },
    {
      fecha: "2025-03-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 13,
    },
    {
      fecha: "2025-03-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 11,
    },
    {
      fecha: "2025-03-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-03-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-03-31",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 12,
    },
    {
      fecha: "2025-04-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 13,
    },
    {
      fecha: "2025-04-02",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 9,
    },
    {
      fecha: "2025-04-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-04-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-04-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-04-06",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2025-04-07",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 6,
    },
    {
      fecha: "2025-04-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 15,
    },
    {
      fecha: "2025-04-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2025-04-10",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 7,
    },
    {
      fecha: "2025-04-11",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 12,
    },
    {
      fecha: "2025-04-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-04-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-04-14",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 19,
    },
    {
      fecha: "2025-04-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 10,
    },
    {
      fecha: "2025-04-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 10,
    },
    {
      fecha: "2025-04-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-04-19",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-04-21",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 13,
    },
    {
      fecha: "2025-04-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2025-04-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 13,
    },
    {
      fecha: "2025-04-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 8,
    },
    {
      fecha: "2025-04-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-04-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 12,
    },
    {
      fecha: "2025-04-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 7,
    },
    {
      fecha: "2025-04-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-05-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-05-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 9,
    },
    {
      fecha: "2025-05-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-05-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-05-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 13,
    },
    {
      fecha: "2025-05-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-05-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-05-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-05-12",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-05-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-05-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-05-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2025-05-16",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-05-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-05-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 9,
    },
    {
      fecha: "2025-05-20",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 7,
    },
    {
      fecha: "2025-05-21",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-05-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-05-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-05-26",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-05-27",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 10,
    },
    {
      fecha: "2025-05-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-05-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 7,
    },
    {
      fecha: "2025-05-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-06-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 8,
    },
    {
      fecha: "2025-06-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 7,
    },
    {
      fecha: "2025-06-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 7,
    },
    {
      fecha: "2025-06-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-06-06",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 7,
    },
    {
      fecha: "2025-06-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-06-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-06-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2025-06-12",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 7,
    },
    {
      fecha: "2025-06-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-06-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-06-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-06-16",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-06-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-06-18",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 7,
    },
    {
      fecha: "2025-06-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-06-20",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-06-22",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
    },
    {
      fecha: "2025-06-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-06-24",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-06-25",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-06-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-06-27",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-06-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-06-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-06-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2025-07-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-07-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-07-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-07-04",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-07-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-07-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-07-08",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-07-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-07-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-07-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 7,
    },
    {
      fecha: "2025-07-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 8,
    },
    {
      fecha: "2025-07-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-07-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-07-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-07-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-07-21",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-07-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2025-07-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-07-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-07-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-07-28",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-07-29",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-07-30",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-08-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-08-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-08-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-08-04",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-08-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-08-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-08-07",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-08-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 6,
    },
    {
      fecha: "2025-08-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-08-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-08-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-08-13",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-08-14",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-08-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-08-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-08-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-08-21",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-08-23",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-08-24",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-08-25",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-08-26",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-08-28",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-09-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-09-02",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-09-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-09-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-09-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
    },
    {
      fecha: "2025-09-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-09-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-09-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-09-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
    },
    {
      fecha: "2025-09-15",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-09-17",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
    },
    {
      fecha: "2025-09-18",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2025-09-19",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
    },
    {
      fecha: "2025-12-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2026-06-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
    {
      fecha: "2026-07-22",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
    },
  ];
  Data.getHospitalizaciones = function () {
    return arreglo;
  };
})();
